import React, { useEffect, useRef, useState } from "react";
import useVisibility from "./hooks/useVisibility";

const AnimatedBorder = ({
  isAnimatedBorderDisabled = false,
  children,
  isSpeaking = false,
}) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // Ensure muted (redundant but safe)
    video.muted = true;
    video.playsInline = true;

    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.catch((error) => {
        console.warn("Autoplay prevented:", error);
        // Optional: show play button or retry on tap
      });
    }
  }, []);

  const [isElVisible, elRef] = useVisibility(100);
  const [hasAnimated, setHasAnimated] = useState(false);
  const [wasAnimated, setWasAnimated] = useState(false);
  useEffect(() => {
    if (
      isElVisible &&
      !hasAnimated &&
      elRef.current &&
      !isAnimatedBorderDisabled &&
      !wasAnimated
    ) {
      setTimeout(() => {
        setHasAnimated(true);
      }, 300);
      setTimeout(() => {
        setHasAnimated(false);
        setWasAnimated(true);
      }, 10000);
    }
  }, [isElVisible, wasAnimated, hasAnimated, elRef, isAnimatedBorderDisabled]);

  return (
    <div className="relative">
      {!isAnimatedBorderDisabled && (
        <div
          className={`myTooltip ${isSpeaking ? "myTooltipLeft" : "myTooltipBottom"} ${hasAnimated ? "visibleTooltip" : ""}`}
        >
          <video
            ref={videoRef}
            width={isSpeaking ? "150" : "284"}
            height={isSpeaking ? "150" : "225"}
            playsInline
            autoPlay
            loop
            muted
          >
            <source
              src={isSpeaking ? "/cert/speaking.webm" : "/cert/screen.webm"}
              type="video/webm"
            />
            Your browser does not support HTML5 video.
          </video>
        </div>
      )}

      <div className={hasAnimated ? "animated-border" : ""} ref={elRef}>
        <style jsx>{``}</style>
        <div className="animated-border-inner">{children}</div>
      </div>
    </div>
  );
};

export default AnimatedBorder;
